import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { useParams } from 'react-router-dom'
import { Box, Button } from '@mui/material'
import useUIFeedback from '@/views/bonus-engine-form/hooks/use-ui-feedback.hook'

import { ApplicationState } from '@/state/root.models'
import { FormStatusType } from '@/enums'
import NavigationBottomComponent from './navegation-bottom.component'

type Props = {
  disableSubmit: boolean
  handleCreateBonusOffer: () => void
}

const NavigationStepComponent = ({
  disableSubmit,
  handleCreateBonusOffer,
}: Props) => {
  const { t } = useTranslation()

  const { bonusFormMode } = useSelector(
    ({ bonusEngine }: ApplicationState) => bonusEngine,
  )

  const params = useParams()

  const param: any = { ...params }

  const { handleAbortCreateBonus } = useUIFeedback()

  return (
    <Box
      sx={{
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 1,
        marginBottom: 1,
        paddingBottom: 3,
      }}
    >
      <Box display="flex" justifyContent="space-between" gap={2}>
        <Button
          className="red"
          variant="text"
          color="primary"
          size="small"
          onClick={(event: React.MouseEvent<HTMLElement, MouseEvent>) =>
            handleAbortCreateBonus(event.currentTarget.getBoundingClientRect())
          }
        >
          {t('labels.cancel').toUpperCase()}
        </Button>
        <Box>
          {param.id === undefined && (
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => handleCreateBonusOffer()}
              disabled={disableSubmit}
            >
              {param.id
                ? bonusFormMode === FormStatusType.DUPLICATE
                  ? t('labels.duplicate').toUpperCase()
                  : t('labels.update').toUpperCase()
                : t('labels.create').toUpperCase()}
            </Button>
          )}
        </Box>
        {param.id && (
          <NavigationBottomComponent
            handleCreateBonusOffer={handleCreateBonusOffer}
            disableSubmit={disableSubmit}
          />
        )}
      </Box>
    </Box>
  )
}

export default NavigationStepComponent
